import React from 'react';
import MainPC from './../components/Main/MainPC';
import { Div } from './../components/TruthCheck/TruthCheckStyle';

function MainPage() {
    return (
        <Div>
            <MainPC />
        </Div>
    );
}

export default MainPage;
